export const commit = '95adb2ba';
